import React, { useState, useEffect } from 'react';
import giftService from '../../../services/giftService';
import walletService from '../../../services/walletService';
import './GiftModal.css';


const GiftModal = ({ isOpen, onClose, receiverId, receiverName }) => {
  const [gifts, setGifts] = useState([]);
  const [selectedGift, setSelectedGift] = useState(null);
  const [message, setMessage] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [giftsRes, walletRes] = await Promise.all([
        giftService.getAvailableGifts(),
        walletService.getWallet()
      ]);

      if (giftsRes.data.success) {
        setGifts(giftsRes.data.data);
      }
      if (walletRes.data.success) {
        setWallet(walletRes.data.data);
      }
    } catch (err) {
      setError('Erreur lors du chargement des données');
    } finally {
      setLoading(false);
    }
  };

  const handleGiftSelect = (gift) => {
    setSelectedGift(gift);
    setError(null);
  };

  const handleSend = async () => {
    if (!selectedGift) {
      setError('Veuillez sélectionner un cadeau');
      return;
    }

    if (wallet.balance < selectedGift.cost) {
      const missing = (selectedGift.cost - wallet.balance).toLocaleString();
      setError(`Solde insuffisant. Il vous manque ${missing} Diamants.`);
      return;
    }


    setSending(true);
    setError(null);

    try {
      const response = await giftService.sendGift(
        receiverId,
        selectedGift.type,
        message,
        isAnonymous
      );

      if (response.data.success) {
        setSuccess('Cadeau envoyé avec succès ! 💝');
        setTimeout(() => {
          onClose();
          setSuccess(null);
          setSelectedGift(null);
          setMessage('');
          setIsAnonymous(false);
        }, 2000);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de l\'envoi du cadeau');
    } finally {
      setSending(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="gift-modal-overlay" onClick={onClose}>
      <div className="gift-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gift-modal-header">
          <h2>🎁 Offrir un cadeau à {receiverName}</h2>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>

        {wallet && (
          <div className="gift-wallet-balance">
            <span>Votre solde : <strong>{(wallet.balance || 0).toLocaleString()} Diamants</strong></span>
          </div>
        )}


        {error && (
          <div className="gift-alert error">
            <span>⚠️</span> {error}
          </div>
        )}

        {success && (
          <div className="gift-alert success">
            <span>🎉</span> {success}
          </div>
        )}

        {loading ? (
          <div className="gift-loading">
            <div className="spinner"></div>
            <p>Chargement des cadeaux...</p>
          </div>
        ) : (
          <>
            <div className="gifts-grid">
              {Array.isArray(gifts) && gifts.map((gift) => (

                <div
                  key={gift.type}
                  className={`gift-item ${selectedGift?.type === gift.type ? 'selected' : ''} ${wallet?.balance < gift.cost ? 'disabled' : ''}`}
                  onClick={() => wallet?.balance >= gift.cost && handleGiftSelect(gift)}
                >
                  <span className="gift-icon">{gift.icon}</span>
                  <span className="gift-name">{gift.name}</span>
                  <span className="gift-cost">{gift.cost.toLocaleString()} Diamants</span>

                  {wallet?.balance < gift.cost && (
                    <span className="gift-disabled-overlay">Solde insuffisant</span>
                  )}
                </div>
              ))}
            </div>

            {selectedGift && (
              <div className="gift-form">
                <div className="gift-selected-info">
                  <span className="selected-icon">{selectedGift.icon}</span>
                  <div className="selected-details">
                    <span className="selected-name">{selectedGift.name}</span>
                    <span className="selected-cost">{selectedGift.cost.toLocaleString()} Diamants</span>

                  </div>
                </div>

                <div className="form-group">
                  <label>Message (optionnel)</label>
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Ajoutez un message personnel..."
                    maxLength={200}
                    rows={3}
                  />
                  <span className="char-count">{message.length}/200</span>
                </div>

                <div className="form-group checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={isAnonymous}
                      onChange={(e) => setIsAnonymous(e.target.checked)}
                    />
                    Envoyer anonymement
                  </label>
                </div>

                <button
                  className="btn-send-gift"
                  onClick={handleSend}
                  disabled={sending}
                >
                  {sending ? 'Envoi en cours...' : `Envoyer pour ${selectedGift.cost.toLocaleString()} Diamants`}

                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default GiftModal;
